import { CONTRACTORS_EVENT } from 'subscriptions/events/events.enum';
import { subscriptionsFabric } from 'subscriptions/subscriptions.fabric';
import schedulePageActions from '../schedulePageActions';
import { worklogsActions, selectActiveSheetsFlat } from 'store/worklogs';
import contractorsPageActions from 'store/contractors/contractorsPageActions';

const handlers = {
  [CONTRACTORS_EVENT.updated]: (store) => (data) => {
    if (!data._id) return;

    const currentURL = window.location.href;
    if (!currentURL.includes('worklog') || currentURL.includes('worklog/submissions')) return;

    // Only the active tab renders these stored sheets; upsert the merged copies so the selector re-groups.
    if (currentURL.includes('worklog/active')) {
      const updated = [];
      selectActiveSheetsFlat(store.getState()).forEach((sheet) => {
        if (sheet.contractorId === data._id && !sheet.published) {
          updated.push({ ...sheet, project: { ...sheet.project, contractor: data } });
        }
      });
      if (updated.length) store.dispatch(worklogsActions.activeSheetsUpdated(updated));
    }

    const organizationLocation = store.getState().personalProfile?.organizationLocation;
    if (organizationLocation) {
      if (!data?.assignedToLocations?.includes(organizationLocation?._id)) {
        store.dispatch(contractorsPageActions.deleteContractor(data?._id));
      }
    }
  },
};

export const contractorsSubscriptionMiddleware = subscriptionsFabric(
  schedulePageActions,
  CONTRACTORS_EVENT,
  handlers,
  { assignedToLocations: (store) => store.getState().schedule.showAllLocations }
);
